export default {
  translation: {
    common: {
      emailOrUsername: 'Email or username',
      invalidEmailOrUsername: 'Invalid email or username',
      invalidPassword: 'Invalid password',
      logInToPlanka: 'log in',
      noInternetConnection: 'No internet connection',
      pageNotFound_title: 'Page Not Found',
      password: 'Password',
      projectManagement: 'project board',
      serverConnectionFailed: 'Server connection failed',
      unknownError: 'Unknown error, try again later',
      useSingleSignOn: 'Use single sign-on',
    },

    action: {
      logIn: 'Log in',
      logInWithSSO: 'Log in with SSO',
    },
  },
};
